import { API_BASE_URL, getHeaders } from "./config";

export const submitSupportTicket = async (ticketData) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/admin/support-tickets/submit`,
      {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify(ticketData),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to submit support ticket");
    }

    return data;
  } catch (error) {
    throw error;
  }
};
